import { IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'
import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'
import OnboardingApi from 'legacy/lut/classes/services/api/OnboardingApi'

import { Logic, Operator } from 'core-components/types'
import { onboardingRequestDetailApi } from 'onboarding/api/OnboardingRequestDetailApi'
import { requestService } from 'onboarding/services/requestService'

export const MD_REMOVAL_PARAMETER = 'Master Dealer Removal'

export async function getMDOffboardingRequest(requestId: number, partnerId: string) {
  const response = await onboardingRequestDetailApi.getRequest(requestId)
  const request = response.data?.request
  if (response.status !== 'success' || !request) {
    throw new Error(response.message || 'Failed to load off-boarding request')
  }
  if (
    request.PartnerId !== partnerId ||
    request.Type !== RequestTypes.Exception ||
    request.MainParameter !== MD_REMOVAL_PARAMETER
  ) {
    throw new Error('The returned request does not match Master Dealer Removal')
  }
  return request
}

export async function findMDOffboardingRequest(partnerId: string): Promise<IRequest | null> {
  const source = requestService.getListCrud(`md-offboarding:${partnerId}`)
  source.setFilter({
    logic: Logic.AND,
    filters: [
      { field: 'Type', operator: Operator.EQUAL, value: RequestTypes.Exception },
      { field: 'PartnerId', operator: Operator.EQUAL, value: partnerId },
      {
        field: 'MainParameter',
        operator: Operator.EQUAL,
        value: MD_REMOVAL_PARAMETER,
      },
    ],
  })
  source.setPaging({ page: 0, pageSize: 50 })
  source.setSort([{ field: 'EntryId', dir: 'desc' }])

  const response = await source.fetch({ force: true })
  if (response.error || !Array.isArray(response.items)) {
    throw new Error(response.error || 'Failed to load off-boarding requests')
  }
  const request = response.items[0]
  if (!request) {
    return null
  }
  if (!request.EntryId) {
    throw new Error('Off-boarding request has no ID')
  }
  return getMDOffboardingRequest(request.EntryId, partnerId)
}

export async function createMDOffboardingRequest(partnerId: string, requestor: string) {
  const existing = await findMDOffboardingRequest(partnerId)
  if (existing) {
    return existing.EntryId
  }
  if (!requestor) {
    throw new Error('Requestor email is required')
  }
  return requestService.createAndStartOne({
    Type: RequestTypes.Exception,
    RequestProps: { MainParameter: MD_REMOVAL_PARAMETER },
    params: { PartnerId: partnerId, Requestor: requestor },
  })
}

export async function rejectMDOffboardingRequest(requestId: number, comment: string) {
  if (!comment.trim()) {
    throw new Error('A rejection reason is required')
  }
  const response = await OnboardingApi.rejectRequest(requestId, comment.trim())
  if (!response.success) {
    throw new Error(String(response.message || 'Failed to reject request'))
  }
}

export function reopenMDOffboardingRequest(requestId: number) {
  return requestService.reopenOne(requestId)
}
